import { render, staticRenderFns } from "./activityPageSettings.vue?vue&type=template&id=09d3053a&scoped=true"
import script from "./activityPageSettings.vue?vue&type=script&lang=js"
export * from "./activityPageSettings.vue?vue&type=script&lang=js"
import style0 from "./activityPageSettings.vue?vue&type=style&index=0&id=09d3053a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d3053a",
  null
  
)

export default component.exports